module.exports = __webpack_public_path__ + "6f08e09b.webp";